export default __webpack_public_path__ + "static/sandro-landscape-dbead3c336b06a84006a3e4044198f14.jpg";